import { useContext } from "react";
import { ApiContext } from "../../contexts/ApiContext";
import { useMutation } from "react-query";
import { WorkOrderAssignmentSubmission } from "../../shared/interfaces/WorkOrder";

export function useAssignMultipleWorkOrders() {
  const apiContext = useContext(ApiContext);
  return useMutation(["assignWorkOrders"], async (workOrderAssignments: WorkOrderAssignmentSubmission[]) =>
    apiContext.assignmentApis.assignMultipleWorkOrders(workOrderAssignments),
  );
}
